import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { HomePageApiService } from './services/HomePageApiService';

/**
 * Hook to fetch home page data once on app mount
 * This prevents unnecessary refetches on every route change
 */
const useHomeData = () => {
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      HomePageApiService.callHomePageAPIs(dispatch);
      hasFetched.current = true;
    }
  }, [dispatch]);
};

export default useHomeData;
